import type { Maybe } from "graphql/jsutils/Maybe";
import { useEffect } from "react";
import type { G_RelatedItemLink } from "~/lib/graphql";
import { sendTrackingSelectOrViewPromotion } from "~/lib/tracking/events";

type UseTrackingCollectionBannerItems = {
  bannerType: "scratch" | "onlineCrane" | "mono";
  scratch: Maybe<Pick<G_RelatedItemLink, "banner" | "url">>;
  onlineCrane: Maybe<Pick<G_RelatedItemLink, "banner" | "url">>;
  mono: Maybe<Pick<G_RelatedItemLink, "banner" | "url">>;
};

export const useTrackingCollectionBannerItems = (args: UseTrackingCollectionBannerItems) => {
  const { bannerType, scratch, onlineCrane, mono } = args;

  useEffect(() => {
    if (bannerType === "scratch" && scratch !== null && scratch !== undefined) {
      sendTrackingSelectOrViewPromotion({
        creativeName: "banner",
        promotionId: "scratch",
        locationId: "footer",
        promotionName: "scratch",
        isView: true,
        misc: scratch.url,
      });
      return;
    }

    if (bannerType === "onlineCrane" && onlineCrane !== null && onlineCrane !== undefined) {
      sendTrackingSelectOrViewPromotion({
        creativeName: "banner",
        promotionId: "onlineCrane",
        locationId: "footer",
        promotionName: "onlineCrane",
        isView: true,
        misc: onlineCrane.url,
      });
      return;
    }

    if (bannerType === "mono" && mono !== null && mono !== undefined) {
      sendTrackingSelectOrViewPromotion({
        creativeName: "banner",
        promotionId: "mono",
        locationId: "footer",
        promotionName: "mono",
        isView: true,
        misc: mono.url,
      });
      return;
    }
  }, [bannerType, scratch, onlineCrane, mono]);
};
